/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FilterIcon2/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FilterIcon2({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FilterIcon2",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FilterIcon2.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-3xKgV': alignSelf,'--mt-2-3xKgV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-3xKgV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-3xKgV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-3xKgV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-3xKgV': opacity,'--w-10-3xKgV': typeof width === 'number' ? `${width}px` : width,'--h-11-3xKgV': typeof height === 'number' ? `${height}px` : height,'--f-12-3xKgV': fill,'--a-7-3xKgV': isAnimated ? animation : "none",'--sd-8-3xKgV': isAnimated ? strokeDashoffset : 0,'--sd-9-3xKgV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FilterIcon2.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.429 0A.429.429 0 000 .429a6.009 6.009 0 004.286 5.754v5.389a.429.429 0 00.666.356l2.571-1.714c.12-.08.191-.213.191-.357V6.183A6.008 6.008 0 0012 .429.429.429 0 0011.572 0H.428z"
 style={{'--f-12-3xKgV': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}